import { SWRConfiguration } from "swr";
import {
  Choice,
  Choices,
  DataSource,
  DataSources,
  Message,
  MessageRole,
  Messages,
  MessageType,
} from "../../../models/Message";
import { APIResponse, useAPI } from "../useAPI";
import endpoints from "./messages.endpoint";
import { MessagesResponse } from "./messages.type";

export const useMessages = (threadId: string, swrOptions?: Partial<SWRConfiguration>): APIResponse<Messages> => {
  return useAPI<MessagesResponse, Messages>(
    endpoints.GET_THREAD_MESSAGES(threadId),
    responseToModel,
    {
      fallbackData: new Messages([]),
      errorRetryCount: 0,
      shouldRetryOnError: false,
      ...swrOptions,
    },
  );
};

const responseToModel = (response: MessagesResponse): Messages => {
  const messagesList = response.messages.map((messageDto) => {
    const dateSources = messageDto.dataSources
      ? new DataSources(
        messageDto.dataSources.map(
          (source) =>
            new DataSource({
              title: source.title,
              content: source.content,
              url: source.url ?? "",
              section: source.section ?? "",
            }),
        ),
      )
      : undefined;

    const choices = messageDto.choices
      ? new Choices(
        messageDto.choices.map(
          (choice) =>
            new Choice({
              label: choice.message,
              value: choice.choiceId,
            }),
        ),
      )
      : undefined;

    return new Message({
      id: messageDto.id,
      threadId: messageDto.threadId,
      role: messageDto.role as MessageRole,
      sender: messageDto.sender,
      recipient: messageDto.recipient || "",
      type: messageDto.type as MessageType,
      content: messageDto.content,
      dataSources: dateSources,
      choices: choices,
      createdAt: new Date(messageDto.createdAt),
    });
  });

  return new Messages(messagesList);
};
